  'use strict'
  
  rules = {
    'name': 'required'
    'email': ['required', 'email']
    'job': 'required'
    'text': 'required'
  }

  attributeNames = {
    'name': 'お名前'
    'email': 'メールアドレス'
    'job': '応募職種'
    'text': '経歴・応募理由'
  }

  errorMessage = {
    'required.name': ':attributeは必須です。',
    'required.email': ':attributeは必須です。',
    'email.email': ':attributeの形式が正しくありません。',
    'required.job': ':attributeは必須です。',
    'required.text': ':attributeは必須です。',
  }

  checkValidate = (data, rule, errorMessage, attributeNames) ->
    validation = new Validator(data, rule, errorMessage)
    validation.setAttributeNames(attributeNames)
    valid = validation.passes()

    for id, val of data
      currentParent = $('#'+id).parent('.p-entry__form__input')
      currentErrorArea = currentParent.children().children('.inner-text')

      if validation.errors.has(id)
        currentParent.removeClass('valid').addClass('error')
        currentErrorArea.text(validation.errors.get(id))
      else
        currentParent.addClass('valid').removeClass('error')
        currentErrorArea.text('')

  $form = $('#form')
  form = $form.get(0)
  $formItems = $form.find('.required').find('input, select, textarea')
  
  $formItems.each(()->
    $(this).get(0).setCustomValidity('')
  )

  $formItems.on('focusout',
    ()->
      target = {}
      rule = {}
      target[$(this).attr('name')] = $(this).val()
      rule[$(this).attr('name')] = rules[$(this).attr('name')]
      checkValidate(target, rule, errorMessage, attributeNames)
  )
  
  $formItems.on('change input',
    (e)->
      target = {}
      rule = {}
      target[$(this).attr('name')] = $(this).val()
      rule[$(this).attr('name')] = rules[$(this).attr('name')]
      checkValidate(target, rule, errorMessage, attributeNames)
  )
  
  $form.find('button').on('click', ()->
    target = {}
    rule = {}
    $formItems.each(
      ()->
        target[$(this).attr('name')] = $(this).val()
        rule[$(this).attr('name')] = rules[$(this).attr('name')]
    )
    checkValidate(target, rule, errorMessage, attributeNames)
  )
  
  $form.on('submit',
    (e)->
      e.preventDefault()
      if not form.checkValidity()
        e.preventDefault()
      else
        formData = $form.serialize()
        localStorage.setItem('form_data', formData)
        
        $.ajax({
          type: 'POST'
          url: '/api/recruit/entry'
          data: formData
          success: (response) ->
            $('.p-entry__form').hide()
            $('.p-entry__form__success__text').html(response.message)
          error: (response) ->
            errorMessage = response.responseJSON.message
            for id, message of errorMessage
              parent = $('#'+id).parent('.p-entry__form__input')
              parent.removeClass('valid').addClass('error')
              parent.children().children('.inner-text').text(message)
        })
  )